import ReportReview from "./component";
import ReportReviewContainer from "./container";

export { ReportReview, ReportReviewContainer };
export default ReportReviewContainer;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/ReportReview/index.ts